import { useState, useEffect } from 'react';
import { supabase } from '../shared/supabase';
import './Admin.css';

const JourneyList = ({ onEdit, onRefresh }) => {
  const [journeys, setJourneys] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchJourneys();
  }, [onRefresh]);

  const fetchJourneys = async () => {
    try {
      setLoading(true);
      const { data, error } = await supabase
        .from('journeys')
        .select('*')
        .order('order_index', { ascending: true });

      if (error) throw error;
      setJourneys(data || []);
    } catch (error) {
      console.error('Error fetching journeys:', error);
      alert('Failed to fetch journeys');
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Are you sure you want to delete this journey?')) {
      return;
    }

    try {
      const { error } = await supabase
        .from('journeys')
        .delete()
        .eq('id', id);

      if (error) throw error;
      
      alert('Journey deleted successfully!');
      fetchJourneys();
    } catch (error) {
      console.error('Error deleting journey:', error);
      alert('Failed to delete journey');
    }
  };

  const toggleActive = async (id, currentStatus) => {
    try {
      const { error } = await supabase
        .from('journeys')
        .update({ active: !currentStatus })
        .eq('id', id);

      if (error) throw error;
      fetchJourneys();
    } catch (error) {
      console.error('Error updating status:', error);
      alert('Failed to update status');
    }
  };

  if (loading) {
    return <div className="loading">Loading journeys...</div>;
  }

  return (
    <div className="journey-list-table">
      <div className="list-header">
        <h2>All Journeys ({journeys.length})</h2>
      </div>

      {journeys.length === 0 ? (
        <div className="empty-state">
          <p>No journeys found. Create your first journey!</p>
        </div>
      ) : (
        <div className="table-container">
          <table className="journeys-table">
            <thead>
              <tr>
                <th>Image</th>
                <th>Title</th>
                <th>Category</th>
                <th>Duration</th>
                <th>Status</th>
                <th>Premium</th>
                <th>Order</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {journeys.map((journey) => (
                <tr key={journey.id}>
                  <td>
                    {journey.image_url ? (
                      <img 
                        src={journey.image_url} 
                        alt={journey.title}
                        className="table-image"
                      />
                    ) : (
                      <div 
                        className="table-image-placeholder"
                        style={{ background: journey.gradient }}
                      />
                    )}
                  </td>
                  <td>
                    <strong>{journey.title}</strong>
                    <div className="table-description">{journey.description?.substring(0, 60)}...</div>
                  </td>
                  <td>{journey.category}</td>
                  <td>{journey.duration || '-'}</td>
                  <td>
                    <span className={`status-badge ${journey.active ? 'active' : 'inactive'}`}>
                      {journey.active ? 'Active' : 'Inactive'}
                    </span>
                  </td>
                  <td>
                    {journey.is_premium && (
                      <span className="premium-badge-table">Premium</span>
                    )}
                  </td>
                  <td>{journey.order_index}</td>
                  <td>
                    <div className="table-actions">
                      <button
                        onClick={() => onEdit(journey)}
                        className="btn-table btn-edit-table"
                        title="Edit"
                      >
                        ✏️
                      </button>
                      <button
                        onClick={() => toggleActive(journey.id, journey.active)}
                        className="btn-table btn-toggle-table"
                        title={journey.active ? 'Deactivate' : 'Activate'}
                      >
                        {journey.active ? '👁️' : '🚫'}
                      </button>
                      <button
                        onClick={() => handleDelete(journey.id)}
                        className="btn-table btn-delete-table"
                        title="Delete"
                      >
                        🗑️
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default JourneyList;